<template>
    <div class="auth-link-social-container">
        <div class="social-link-msg">
            <slot name="message"></slot>
        </div>
        <div class="social-link-btns">
            <button
                v-for="(btn, indx) in socials"
                :key="indx"
                :class="socialBtnClass(btn)"
                @click="handleSocialLinkClick(btn, { mode: 'link', role: role })"
                @mouseenter="handleSocialHover(btn)"
                @mouseleave="handleSocialHover(btn)"
            >
                <img
                    v-if="btn.hovered && btn.active"
                    :src="URLS.icons.hoveredUnselect"
                    class="social-btn-unselect-icon"
                />
                <img
                    v-else-if="btn.hovered && !btn.active"
                    :src="URLS.icons.hoveredSelect"
                    class="social-btn-select-icon"
                />
                <img v-else-if="!btn.hovered" :src="btn.icon" class="social-btn-icons" />
            </button>
        </div>
    </div>
</template>
<script>
    import { useAuthSocial } from '@/composables/auth/useAuthSocial'
    export default {
        name: 'AuthLinkSocial',
        props: {
            role: {
                required: true,
                type: String,
                validator: (v) => ['venue', 'artist'].includes(v)
            }
        },
        setup(props) {
            const { URLS, socialBtnClass, socials, handleSocialLinkClick, handleSocialHover } =
                useAuthSocial(props)

            return {
                URLS,
                socialBtnClass,
                socials,
                handleSocialLinkClick,
                handleSocialHover
            }
        }
    }
</script>
<style lang="scss" scoped>
    .auth-link-social-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;

        .social-link-msg {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-front;
            width: 100%;
        }
        .social-link-btns {
            display: flex;
            max-width: 300px;
            width: 100%;
            flex-direction: row;
            gap: 8px;

            button {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                border: none;
                width: 36px;
                height: 36px;

                .social-btn-icons {
                    width: 20px;
                    height: 20px;
                }
                .social-btn-select-icon,
                .social-btn-unselect-icon {
                    width: 36px;
                    height: 36px;
                }
            }

            .social-btn-hovered {
                padding: none !important;
                background: #cdeb09 !important;
            }
            .social-btn-active {
                background: #cdeb09;
            }
            .social-btn-inactive {
                background: #333333;
            }
        }
    }
</style>
